import { httpClient } from '@/shared/api/client.ts'
import { AirdropResponse } from '@/domains/auth/api/types'

export function fetchAirdrop() {
  return httpClient.get('member/airdrop').json<AirdropResponse>()
}
